import React, { Fragment, useEffect, useState } from 'react'
import { Link, useSearchParams } from "react-router-dom";
import Humberg from '../../../../elements/Humberg';
import { useDispatch, useSelector } from 'react-redux';
import { singleProductAction } from '../../../../redux/actions/productActions';
import { clearErrors } from '../../../../redux/actions/userActions';
import { toast } from 'react-toastify'
import HoverFullText from "../../../../elements/HoverToolKit";
import Loader from '../../../loader/loader';
import { formatWhatsAppNumber } from '../../../../utils/whatsappLinkFormater';

const ProductDetails = () => {



    const [copied, setCopied] = useState(false);






    const dispatch = useDispatch()




    const { loading, error, product } = useSelector((state) => state.Products)

    const { user } = useSelector((state) => state.verifyEmailStore)

    const [searchParams] = useSearchParams();
    const id = searchParams.get("id");



    useEffect(() => {

        if (id) {
            dispatch(singleProductAction(id))
        }

        document.title = "Product Details";


    }, [id, dispatch])


    useEffect(() => {
        if (error) {
            toast.error(error)
            dispatch(clearErrors())
        }
    }, [error, dispatch])




    const handleCopy = async (value) => {
        try {
            await navigator.clipboard.writeText(value);
            setCopied(true);

            setTimeout(() => {
                setCopied(false);
            }, 1500);
        } catch (err) {
            console.error("Failed to copy:", err);
        }
    };

    const [activeImage, setActiveImage] = useState("custom");
    const [isPreviewOpen, setIsPreviewOpen] = useState(false);

    // Auto switch every 10 seconds
    useEffect(() => {
        const interval = setInterval(() => {
            setActiveImage((prev) =>
                prev === "custom" ? "amz" : "custom"
            );
        }, 10000);

        return () => clearInterval(interval);
    }, []);

    const currentImage =
        activeImage === "custom"
            ? product?.custom_image
            : product?.amz_image;




    const handleCopyProductDetails = async () => {
        try {
            const text = `
                Product ID: ${product?.id}
                Market: ${product?.market || "N/A"}
                Seller ID: ${product?.seller_pmm_id || "N/A"}
                Seller Name: ${product?.amz_seller || "N/A"}
                Keyword: ${product?.keywords || "N/A"}
                Commission: ${product?.pm_commission || "N/A"}
                Category: ${product?.category_name || "N/A"}
                Product Type: ${product?.product_type_name || "N/A"}
        `;

            await navigator.clipboard.writeText(text.trim());

            toast.success("Product details copied ✅");
        } catch (err) {
            console.error(err);
            toast.error("Failed to copy ❌");
        }
    };

    return (
        <Fragment>
            {loading && <Loader />}
            <Humberg header="Products" headerLink="/products" children={"Products Details"} />
            <section className='p-[1.5vmax]' >
                <div className="bg-white p-[2vmax] rounded-xl shadow-1 grid gridcols-1 lg:grid-cols-[33%_67%] gap-[2vmax] relative ">
                    <div className="border-2 border-gray-100 rounded-lg lg:sticky top-[5vmax] self-start pt-[2vmax]">

                        {/* Main Image */}
                        <div
                            className="w-full h-[25vmax] overflow-hidden flex-center p-[1.5vmax] cursor-pointer mb-[2vmax]"
                            onClick={() => setIsPreviewOpen(true)}
                        >
                            <img src={currentImage} alt="" />
                        </div>

                        {/* Thumbnails */}
                        <div className="flex-center gap-[1vmax] border-t-2 border-gray-100 py-[1vmax]">

                            {/* Custom */}
                            <div
                                onClick={() => setActiveImage("custom")}
                                className={`w-[7vmax] h-[7vmax] lg:w-[4vmax] lg:h-[4vmax] rounded-md border-[0.15vmax] 
                                border-gray-300 flex-center cursor-pointer transition overflow-hidden
                                ${activeImage === "custom" ? "opacity-100 border-green-500" : "opacity-40"}
                                `}
                            >
                                <img src={product?.custom_image} alt="" className="w-full" />
                            </div>

                            {/* Amazon */}
                            <div
                                onClick={() => setActiveImage("amz")}
                                className={`w-[7vmax] h-[7vmax] lg:w-[4vmax] lg:h-[4vmax] rounded-md border-[0.15vmax] 
                                border-gray-300 flex-center cursor-pointer transition overflow-hidden
                                ${activeImage === "amz" ? "opacity-100 border-green-500" : "opacity-40"}
                                `}
                            >
                                <img src={product?.amz_image} alt="" className="w-full" />
                            </div>
                        </div>
                        <div className="flex-center gap-[1vmax]  pb-[1vmax]">
                            {user?.role === "PMM" &&
                                <Link to={`/products/update-product?id=${product?.id}`} className='bg-gray-200 border-[0.1vmax] text-gray-600 rounded-md font-3text-[1.5vmax] lg:text-[1vmax] p-[0.5vmax_1vmax]' >
                                    <i className="fa-regular fa-pen-to-squaretext-[1.5vmax] lg:text-[1vmax]"></i>
                                    &nbsp;&nbsp; Edit
                                </Link>
                            }

                            <button
                                onClick={handleCopyProductDetails}
                                className="bg-blue-500 border-[0.1vmax] text-white rounded-md font-3
                            text-[1.5vmax] lg:text-[1vmax] p-[0.5vmax_1vmax]"
                            >
                                Copy Details
                            </button>
                            <div className='bg-green-500 border-[0.1vmax] text-white rounded-md font-3
                            text-[1.5vmax] lg:text-[1vmax] p-[0.5vmax_1vmax]' >
                                <i className="fa-solid fa-diagram-projecttext-[1.5vmax] lg:text-[1vmax]"></i>
                                &nbsp;&nbsp; {product?.status}
                            </div>
                        </div>
                    </div>
                    <div className="">
                        <span className='text-[2vmax] lg:text-[1.5vmax] font-3 uppercase font-[900] text-black' >
                            Product Details
                        </span>
                        <div className="grid grid-cols-2 lg:grid-cols-4 mt-[2vmax] space-y-[1vmax] lg:space-y-0">
                            <div className='overflow-hidden' >
                                <span className='text-[1.3vmax]  lg:text-[0.8vmax] text-gray-400 uppercase font-3 font-[700]' >
                                    Amazon Seller
                                </span>
                                <br />
                                <span className='text-[1.5vmax] lg:text-[1.1vmax] text-gray-700  font-3 font-[600] inline-block pt-[0.7vmax]' >
                                    <HoverFullText text={product?.amz_seller || "Not Available"} sliceLength={14} />
                                </span>
                            </div>
                            <div>
                                <span className='text-[1.3vmax] lg:text-[0.8vmax] text-gray-400 uppercase font-3 font-[700]' >
                                    Brand Name
                                </span>
                                <br />
                                <span className='text-[1.5vmax] lg:text-[1.1vmax] text-gray-700  font-3 font-[600] inline-block pt-[0.7vmax]' >
                                    {product?.brand_name || <i>Not Available</i>}
                                </span>
                            </div>
                            <div>
                                <span className='text-[1.3vmax] lg:text-[0.8vmax] text-gray-400 uppercase font-3 font-[700]' >
                                    Product ID
                                </span>
                                <br />
                                <span className='text-[1.5vmax] lg:text-[1.1vmax] text-gray-700  font-3 font-[600]  pt-[0.7vmax] flex' >
                                    {product?.id}
                                    &nbsp;&nbsp;
                                    <button
                                        onClick={() => handleCopy(product?.id)}
                                        className="flex items-center gap-1 text-sm"
                                        title={copied ? "Copied" : "Copy"}
                                    >
                                        <i
                                            className={`fa-regular ${copied ? "fa-circle-check text-green-600" : "fa-copy"
                                                }`}
                                        ></i>
                                    </button>
                                </span>
                            </div>
                            <div>
                                <span className='text-[1.3vmax] lg:text-[0.8vmax] text-gray-400 uppercase font-3 font-[700]' >
                                    Market
                                </span>
                                <br />
                                <span className='text-[1.5vmax] lg:text-[1.1vmax] text-gray-700  font-3 font-[600] inline-block pt-[0.7vmax]' >
                                    <HoverFullText text={product?.market} sliceLength={14} />
                                </span>
                            </div>
                        </div>
                        <div className="grid  grid-cols-2 lg:grid-cols-[50%_25%_25%] mt-[2vmax] space-y-[1vmax] lg:space-y-0">
                            <div>
                                <span className='text-[1.3vmax] lg:text-[0.8vmax] text-gray-400 uppercase font-3 font-[700]' >
                                    Keyword
                                </span>
                                <br />
                                <span className='text-[1.5vmax] lg:text-[1.1vmax] text-gray-700  font-3 font-[600] inline-block pt-[0.7vmax]' >
                                    <HoverFullText text={product?.keywords} sliceLength={34} />
                                </span>
                            </div>
                            {user?.role !== "PM" &&
                                <div>
                                    <span className='text-[1.3vmax] lg:text-[0.8vmax] text-gray-400 uppercase font-3 font-[700]' >
                                        Chinese Seller
                                    </span>
                                    <br />
                                    <span className='text-[1.5vmax] lg:text-[1.1vmax] text-gray-700  font-3 font-[600] inline-block pt-[0.7vmax]' >
                                        {product?.seller_type}
                                    </span>
                                </div>


                            }
                            <div>
                                <span className='text-[1.3vmax] lg:text-[0.8vmax] text-gray-400 uppercase font-3 font-[700]' >
                                    Seller ID
                                </span>
                                <br />
                                <span className='text-[1.5vmax] lg:text-[1.1vmax] text-gray-700  font-3 font-[600] flex pt-[0.7vmax]' >
                                    {String(product?.seller_pmm_id).padStart(2, '0') || "N/A"}
                                </span>
                            </div>
                        </div>
                        <div className="grid grid-cols-2 lg:grid-cols-4 mt-[2vmax] space-y-[1vmax] lg:space-y-0">
                            <div>
                                <span className='text-[1.3vmax] lg:text-[0.8vmax] text-gray-400 uppercase font-3 font-[700]' >
                                    Commission
                                </span>
                                <br />
                                <span className='text-[1.5vmax] lg:text-[1.1vmax] text-gray-700  font-3 font-[600] inline-block pt-[0.7vmax]' >
                                    Rs. {product?.pm_commission}
                                </span>
                            </div>
                            {user?.role !== "PM" &&
                                <div>
                                    <span className='text-[1.3vmax] lg:text-[0.8vmax] text-gray-400 uppercase font-3 font-[700]' >
                                        Zonify Pro Commission
                                    </span>
                                    <br />
                                    <span className='text-[1.5vmax] lg:text-[1.1vmax] text-gray-700  font-3 font-[600] inline-block pt-[0.7vmax]' >
                                        Rs. {product?.portal_commission}
                                    </span>
                                </div>
                            }
                            <div>
                                <span className='text-[1.3vmax] lg:text-[0.8vmax] text-gray-400 uppercase font-3 font-[700]' >
                                    Category
                                </span>
                                <br />
                                <span className='text-[1.5vmax] lg:text-[1.1vmax] text-gray-700  font-3 font-[600] inline-block pt-[0.7vmax]' >
                                    <HoverFullText text={product?.category_name} sliceLength={14} />
                                </span>
                            </div>
                            <div>
                                <span className='text-[1.3vmax] lg:text-[0.8vmax] text-gray-400 uppercase font-3 font-[700]' >
                                    Product Type
                                </span>
                                <br />
                                <span className='text-[1.5vmax] lg:text-[1.1vmax] text-gray-700  font-3 font-[600] inline-block pt-[0.7vmax]' >
                                    <HoverFullText text={product?.product_type_name} sliceLength={14} />

                                </span>
                            </div>

                        </div>
                        <div className="grid  grid-cols-2 lg:grid-cols-[25%_50%_25%] mt-[2vmax] space-y-[1vmax] lg:space-y-0">
                            <div>
                                <span className='text-[1.3vmax] lg:text-[0.8vmax] text-gray-400 uppercase font-3 font-[700]' >
                                    Seller Contact
                                </span>
                                <br />
                                <span className='text-[1.5vmax] lg:text-[1.1vmax] text-gray-700  font-3 font-[600] inline-block pt-[0.7vmax]' >
                                    {product?.country_code} {product?.phone_number}
                                </span>
                            </div>
                            <div>
                                <span className='text-[1.3vmax] lg:text-[0.8vmax] text-gray-400 uppercase font-3 font-[700]' >
                                    Seller Whatsapp
                                </span>
                                <br />
                                <span className='text-[1.5vmax] lg:text-[1.1vmax] text-gray-700  font-3 font-[600] inline-block pt-[0.7vmax] flex' >
                                    <HoverFullText text={product?.country_code + " " + product?.phone_number} sliceLength={18} />
                                    <a href={formatWhatsAppNumber(product?.country_code, product?.phone_number)} target="_blank" rel="noopener noreferrer" className="">
                                        &nbsp;&nbsp;<i className="fa-solid fa-arrow-up-right-from-square text-black"></i>
                                    </a>
                                </span>
                            </div>
                            <div>
                                <span className='text-[1.3vmax] lg:text-[0.8vmax] text-gray-400 uppercase font-3 font-[700]' >
                                    Status
                                </span>
                                <br />

                                <span className={`text-center text-[1.3vmax] lg:text-[0.8vmax] font-3 capitalize font-[700] p-[0.2vmax_0.5vmax] inline-block mt-[0.7vmax]
                        ${product?.status === "COMPLETED" ? "bg-blue-100 text-blue-500" : (product?.status === "CANCELLED" || product?.status === "SUSPENDED") ? "bg-orange-100 text-orange-400" : product?.status === "SYSTEM_CANCELLED" ? "bg-red-100 text-red-500" : "bg-green-100 text-green-500"
                                    }
                        `}
                                >
                                    {
                                        product?.status === "COMPLETED" ? "Completed"
                                            :
                                            product?.status === "CANCELLED" ? "Cancelled"
                                                :
                                                product?.status === "SYSTEM_CANCELLED" ? "System Cancel"
                                                    :
                                                    product?.status === "SUSPENDED" ? "Suspended"
                                                        :
                                                        product?.status === "INACTIVE" ? "Inactive" : product?.status
                                    }
                                </span>
                            </div>

                        </div>
                        <div className="flex-center mt-[2vmax] mb-[1vmax] py-[1vmax] bg-gray-100 mr-[2vmax] rounded-lg ">
                            <span className='text-[1.2vmax] text-gray-600 uppercase font-3 font-[700]' >Product Price :

                            </span>
                            <span className='text-[1.5vmax] font-3 uppercase inline-block  font-[800] text-[#f7577e]' >
                                &nbsp;&nbsp;&nbsp;{product?.currency} {product?.product_price}
                            </span>
                        </div>
                        <div className="grid grid-cols-2 lg:grid-cols-5 mt-[2vmax] space-y-[1vmax] lg:space-y-0">
                            <div>
                                <span className='text-[1.3vmax] lg:text-[0.8vmax] text-gray-400 uppercase font-3 font-[700]' >
                                    Overall Limit
                                </span>
                                <br />
                                <span className='text-[1.5vmax] lg:text-[1.1vmax] text-gray-700  font-3 font-[600] inline-block pt-[0.7vmax]' >
                                    {product?.overall_sales_limit || 0}
                                </span>
                            </div>
                            <div>
                                <span className='text-[1.3vmax] lg:text-[0.8vmax] text-gray-400 uppercase font-3 font-[700]' >
                                    Orders Left
                                </span>
                                <br />
                                <span className='text-[1.5vmax] lg:text-[1.1vmax] text-gray-700  font-3 font-[600] inline-block pt-[0.7vmax]' >
                                    {product?.overall_limit_left || 0}
                                </span>
                            </div>
                            <div>
                                <span className='text-[1.3vmax] lg:text-[0.8vmax] text-gray-400 uppercase font-3 font-[700]' >
                                    Daily Limit
                                </span>
                                <br />
                                <span className='text-[1.5vmax] lg:text-[1.1vmax] text-gray-700  font-3 font-[600] inline-block pt-[0.7vmax]' >
                                    {product?.daily_sales_limit || 0}
                                </span>
                            </div>
                            <div>
                                <span className='text-[1.3vmax] lg:text-[0.8vmax] text-gray-400 uppercase font-3 font-[700]' >
                                    Today Remaining
                                </span>
                                <br />
                                <span className='text-[1.5vmax] lg:text-[1.1vmax] text-gray-700  font-3 font-[600] inline-block pt-[0.7vmax]' >
                                    {product?.today_limt_left || 0}
                                </span>
                            </div>

                            <div>
                                <span className='text-[1.3vmax] lg:text-[0.8vmax] text-gray-400 uppercase font-3 font-[700]' >
                                    Reservations
                                </span>
                                <br />
                                <span className='text-[1.5vmax] lg:text-[1.1vmax] text-gray-700  font-3 font-[600] inline-block pt-[0.7vmax]' >
                                    {product?.overall_reserved || 0}
                                </span>
                            </div>

                        </div>
                        <div className=" pt-[2vmax]">
                            <span className='text-[1.2vmax] text-gray-600 uppercase font-3 font-[700]' >
                                1. Instructions
                            </span>
                            <div className="pt-[0.7vmax]text-[1.5vmax] lg:text-[1vmax] text-gray-500 font-2 pr-[3vmax] font-[400]"
                                dangerouslySetInnerHTML={{ __html: product?.instruction_paragraph }}
                            />
                        </div>
                        <div className=" pt-[2vmax]">
                            <span className='text-[1.2vmax] text-gray-600 uppercase font-3 font-[700]' >
                                2.  Refund Policy
                            </span>
                            <div className="pt-[0.7vmax]text-[1.5vmax] lg:text-[1vmax] text-gray-500 font-2 pr-[3vmax] font-[400]"
                                dangerouslySetInnerHTML={{ __html: product?.refund_paragraph }}
                            />
                        </div>
                        <div className=" pt-[2vmax]">
                            <span className='text-[1.2vmax] text-gray-600 uppercase font-3 font-[700]' >
                                3. Commission Policy
                            </span>
                            <div className="pt-[0.7vmax]text-[1.5vmax] lg:text-[1vmax] text-gray-500 font-2 pr-[3vmax] font-[400]"
                                dangerouslySetInnerHTML={{ __html: product?.commission_paragraph }}
                            />
                        </div>
                    </div>

                </div>
            </section>
            {/* FULLSCREEN PREVIEW */}
            {isPreviewOpen && (
                <div className="fixed inset-0 bg-black bg-opacity-80 z-[9999999999] flex flex-col items-center justify-center">

                    {/* Close Button */}
                    <button
                        onClick={() => setIsPreviewOpen(false)}
                        className="absolute top-6 right-8 text-white text-3xl"
                    >
                        ✕
                    </button>

                    {/* Large Image */}
                    <div className="w-[80%] h-[70vh] flex-center">
                        <img
                            src={currentImage}
                            alt=""
                            className="max-h-full object-contain"
                        />
                    </div>

                    {/* Thumbnails inside modal */}
                    <div className="flex gap-6 mt-6">

                        <div
                            onClick={() => setActiveImage("custom")}
                            className={`w-[6vmax] h-[6vmax] rounded-md cursor-pointer transition flex-center overflow-hidden border-2 
                            ${activeImage === "custom" ? "opacity-100 border-green-500" : "opacity-50 border-white"}
                        `}
                        >
                            <img src={product?.custom_image} alt="" className="w-full" />
                        </div>

                        <div
                            onClick={() => setActiveImage("amz")}
                            className={`w-[6vmax] h-[6vmax] rounded-md cursor-pointer transition overflow-hidden border-2 
                                ${activeImage === "amz" ? "opacity-100 border-green-500" : "opacity-50 border-white"}
                            `}
                        >
                            <img src={product?.amz_image} alt="" className="w-full" />
                        </div>
                    </div>
                </div>
            )}

        </Fragment>
    )
}

export default ProductDetails